export const hello = () => 'hello';

export * from './consultMember';
export * from './seqConsultBanner';
